import dayjs from "dayjs";

export function DateTimeLabel({ value }: { value?: string }) {
    return <span>{value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "-"}</span>;
}
